function Input({ value, onChange, placeholder, className, label, name }) {
  return (
    <div className="relative">
      {label && (
        <label
          className={`text-sm absolute left-3 transition-all duration-150 pointer-events-none ${
            value
              ? "-top-3.5 bg-white text-slate-500"
              : "top-3.5 text-slate-400"
          }`}
        >
          {label}
        </label>
      )}
      <input
        name={name}
        value={value}
        onChange={onChange}
        className={`rounded-lg p-2 resize-none flex-1 ${className}`}
      />
    </div>
  );
}

export default Input;
